import { useTranslation } from "react-i18next";

const LABELS = {
  en: {
    title: "Event colors",
    max: "Max events",
    raids: "Raid Hour / Raid Day",
    featured: "Spotlight Hour / Community Day",
    friendship: "Friendship Friday",
    hatch: "Hatch / special events",
    other: "Other events",
    movie: "Movie Night",
    menza: "MunnaMenza",
    community: "Our community events",
  },
  hu: {
    title: "Jelmagyarázat",
    max: "Max események",
    raids: "Raid Hour / Raid Day",
    featured: "Spotlight Hour / Community Day",
    friendship: "Friendship Friday",
    hatch: "Hatch / Specialis események",
    other: "Egyéb események",
    movie: "Filmest",
    menza: "MunnaMenza",
    community: "Saját közösségi eseményeink",
  },
  de: {
    title: "Farblegende",
    max: "Max-Events",
    raids: "Raid Hour / Raid Day",
    featured: "Spotlight Hour / Community Day",
    friendship: "Friendship Friday",
    hatch: "Hatch / Special events",
    other: "Weitere Events",
    movie: "Filmabend",
    menza: "MunnaMenza",
    community: "Unsere Community-Events",
  },
} as const;

type LegendKey = Exclude<keyof typeof LABELS.en, "title">;

// Reuse the card/calendar theme classes so palette edits also update the legend.
const ITEMS: ReadonlyArray<{ key: LegendKey; theme: string }> = [
  { key: "max", theme: "event-max" },
  { key: "raids", theme: "event-raid" },
  { key: "featured", theme: "event-featured" },
  { key: "friendship", theme: "event-friendship" },
  { key: "hatch", theme: "event-hatch" },
  { key: "other", theme: "event-other" },
  { key: "movie", theme: "movie-night" },
  { key: "menza", theme: "munnamenza" },
  { key: "community", theme: "community-event" },
];

type EventLegendProps = {
  className?: string;
};

export default function EventLegend({ className = "" }: EventLegendProps) {
  const { t, i18n } = useTranslation();
  const language = (i18n.language || "en").toLowerCase();
  const labels = language.startsWith("hu")
    ? LABELS.hu
    : language.startsWith("de")
      ? LABELS.de
      : LABELS.en;
  const title = t("eventsPage.legend.title", labels.title);

  return (
    <aside className={`event-legend ${className}`.trim()} aria-label={title}>
      <ul className="event-legend__items" role="list">
        {ITEMS.map(item => (
          <li className="event-legend__item" key={item.key}>
            <span
              className={`event-legend__swatch event-themed ${item.theme}`}
              aria-hidden="true"
            />
            <span>{t(`eventsPage.legend.${item.key}`, labels[item.key])}</span>
          </li>
        ))}
      </ul>
    </aside>
  );
}
